/** @module csi/def/AddPath */
define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/core/extendedPathService",
	"csi/reflection",
	"csi/resolver",
	"csi/util",
	"csi/xml"
], function(array, declare, {parsePathSteps}, reflection, resolver, util, xml) {

	return declare(null, {
		/** @property {string} m_path - full path to be used as limit path; supports extended path syntax */
		m_path: null,

		/** @property {string} [m_typeToFind] - class type to find by repeating path */
		m_typeToFind: null,

		/** @property {boolean} [m_bParentContext] - use parent class instead of view class to start traversal */
		m_bParentContext: false,

		/** @property {string} [m_pathParent] - path to use on parent to mirror m_path on child */
		m_pathParent: null,

		/** @property {string} [m_pathSuffix] - path to append to resulting path */
		m_pathSuffix: null,

		constructor: function(def) {
			// FIX: could we change this to have path prefix and suffix rather than parent context?
			this.m_path = util.getProperty(def, 'Path');
			this.m_typeToFind = util.getProperty(def, 'To');
			this.m_bParentContext = util.getBooleanProperty(def, 'ParentContext');
			this.m_pathParent = util.getProperty(def, 'ParentContextPath');
			this.m_pathSuffix = util.getProperty(def, 'PathSuffix');
		},

		/**
		 * Resolve full path when not explicitly specified, and validate that it exists
		 * @param {Class} rcRoot - starting class of path
		 * @param {Node} nodeRoot - starting node of path
		 */
		resolvePath: function(rcRoot, nodeRoot) {
			var path, parentPaths, rc;

			var traverseParentPath = function(rcSource) {
				var n = parentPaths.length;
				var rcTarget;

				array.some(parentPaths, function(p, i) {
					if (rcTarget = rcSource.getPathClass(p)) {
						// paths after this one are no longer relevant
						if (i + 1 < n) {
							parentPaths.splice(i + 1, n - i);
						}

						return true;
					}
				});

				return rcTarget;
			};

			// typeToFind is just a hint for parent target class if specified with ParentContext and not ParentPath
			if (this.m_typeToFind && (!this.m_bParentContext || this.m_pathParent)) {
				// in cases where the path is mirrored from one set of classes to another (main hierarchy vs line planning hierarchy),
				// it is only possible to find the path depth on the main hierarchy, so switch to parent before traversing
				if (this.m_bParentContext && this.m_pathParent) {
					rcRoot = reflection.getNodeClass(resolver.resolveParent(nodeRoot));
				}

				if (!rcRoot) {
					console.warn('csi.def.AddPath.resolvePath - cannot resolve path without root class.');
					return;
				}

				var rc = rcRoot;
				var type = rcRoot.getType();

				if (type != this.m_typeToFind) {
					// traverse path until target class found
					parentPaths = (this.m_bParentContext && this.m_pathParent) ? this.m_pathParent.split(";") : [];

					// reverse paths so that the paths lower in the hierarchy are tested first
					if (parentPaths.length) {
						parentPaths = parentPaths.reverse();
					}
				}

				while (rc && (type != this.m_typeToFind)) {
					if (parentPaths.length) {
						rc = traverseParentPath(rc);
					} else {
						rc = rc.getPathClass(this.m_path);
					}

					path = xml.pathAddStep(path, this.m_path);

					// make sure path is not recursive
					if (rc && (rc.getType() == type)) {
						rc = null;
					} else if (rc) {
						type = rc.getType();
					}
				}

				if (!rc) {
					console.warn('csi.def.AddPath.resolvePath - path does not exist from "' + rcRoot.getType() + '" to "' + this.m_typeToFind + '" using path "' + this.m_path + '".');
					return;
				}
			} else {
				path = this.m_path;
			}

			// add suffix to path if any
			if (this.m_pathSuffix) {
				path = xml.pathAddStep(path, this.m_pathSuffix);
			}

			this.m_path = path;
		},
	});
});